<template>
 <v-container
    id="scroll-target"
    class="overflow-y-auto"
   >
   <div v-if="this.VacationData.VacationDetail[0] != null" class="text-wrap" v-scroll:#scroll-target="onScroll">
      <v-col  style="height: 100%;" class="pt-15 mt-n6">
         <v-row class="pb-1">
            <h4  style="font-size: 14px">{{ $t("vacation_detail_creator") }}</h4>
            <v-divider class="divider"></v-divider>
         </v-row>
         <v-row>
            <p style="font-size: 14px">{{ this.VacationData.userInfomation.name }}</p>
         </v-row>
         <v-row class="mt-n4">
            <p style="font-size: 14px">{{ $t("common_section") }}: {{ this.VacationData.userInfomation.section }}</p>
         </v-row>
         <v-row class="mt-n4">
            <p style="font-size: 14px">{{ $t("vacation_detail_created_at") }} {{formatDate(this.VacationData.VacationDetail[0].created_at)}}</p>
         </v-row>
         <v-row class="mt-1 pb-1">
            <h4 style="font-size: 14px">{{ $t("register_vacation_description") }}</h4>
            <v-divider class="divider"></v-divider>
         </v-row>
         <v-row>
            <p style="font-size: 14px;white-space: pre-line">{{vacationDescription}}</p>
         </v-row>
         <div v-if="getStatus() == 1">
            <v-row class="pb-1 mt-1">
               <h4 style="font-size: 14px">{{ $t("vacation_detail_approve_information") }}</h4>
               <v-divider class="divider"></v-divider>
            </v-row>
            <v-row>
               <p style="font-size: 14px">{{ $t("vacation_detail_approved_by") }}  {{ getApproverName() }}</p>
            </v-row>
            <v-row class="mt-n4">
               <p style="font-size: 14px">{{ $t("vacation_detail_at") }} {{formatDate(this.VacationData.VacationDetail[0].apply_date)}}</p>
            </v-row>
            <v-row class="mt-n4">
               <p style="font-size: 14px;white-space: pre-line">{{ $t("vacation_detail_note") }} {{reasonManager}}</p>
            </v-row>
          </div>
          <div v-if="getStatus() == 2">
            <v-row class="mt-1 pb-1">
               <h4 style="font-size: 14px">{{ $t("vacation_detail_reject_information") }}</h4>
               <v-divider class="divider"></v-divider>
            </v-row>
            <v-row>
               <p style="font-size: 14px">{{ $t("vacation_detail_rejected_by") }}  {{ this.VacationData.approverInformation.name }}</p>
            </v-row>
            <v-row class="mt-n4">
               <p style="font-size: 14px">{{ $t("vacation_detail_rejected_at") }} {{formatDate(this.VacationData.VacationDetail[0].apply_date)}}</p>
            </v-row>
            <v-row class="mt-n4">
               <p style="font-size: 14px;white-space: pre-line">{{ $t("vacation_detail_note") }} {{reasonManager}}</p>
            </v-row>
          </div>
      </v-col>
   </div>
 </v-container>
  
    
</template>
<script>
   import { mapGetters, mapState } from "vuex";
   import { DefaultValues } from "@/utilities/CommonUtilities";
   import moment from 'moment';
    export default {
      name :'ContentVacation',
      props:{
        VacationData: Object
      },
      data () {
        return {
          onScroll: {"onScroll": "onScroll"}
            }
        },
      
      computed:{
         ...mapState(["listUser", "token", "listReason"]),
        ...mapGetters(["getUserByID"]),
        ...mapGetters(["getReasonByID"]),
        ...mapState(["userInfo"]),
        vacationDescription() {
          return (this.VacationData.VacationData.description == null || this.VacationData.VacationData.description == "null") ? DefaultValues.none_string : this.VacationData.VacationData.description;
        },
        reasonManager() {
          return this.VacationData.VacationDetail[0].reason_manager == null ? DefaultValues.none_string : this.VacationData.VacationDetail[0].reason_manager;
        },
        },
        methods: {
             formatDate(value){
            if (value) {
             this.checkisValid = true;
             return moment(String(value), "YYYY-MM-DD hh:mm:ss").format('DD/MM/YYYY HH:mm:ss');
           }
      
         },
         getApproverName(){
           return this.VacationData.approverInformation.name;
         },
         getStatus(){
           return this.VacationData.VacationDetail[0].status;
         },
    },
    inject: ["dataSource", "notifyBus"],
  }
</script>
<style scoped>
   .divider {
     margin-top: 12px;
     margin-right: 10px;
     margin-left: 10px
   }
   .footer.content > img,
   .footer.content > p {
     display: inline-block;
   }
  .leaveType{
     font-size: 14px
   }
  .reason{
     font-size: 14px
  }
  #leftTime{
     background-color: #F4F4F4;
     width: 50%;
     float: left;
     height: 50px;
     margin: 0px;
     padding: 0px
  }
  #rightTime{
     background-color: #F4F4F4;
     width: 50%;
     float: left;
     height: 50px;
  }
</style>
